// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"1d1e972e","627":"da856a0e","631":"34350a1a","643":"a9c00613","748":"4ea3a41c","764":"2f1ae057","787":"05b81acb","922":"03775057","973":"3fb0254b"}[chunkId] + ".chunk.js";
};